import { useCallback } from "react";
import { useApi } from "../api/context";
import { setActingAs } from "../shell/actingAs";
import { navigate } from "../shell/history";
import { SIGN_IN_PATH } from "./returnTo";

/** Ends the session, then leaves for the sign-in page; that page renders outside the signed-in shell, which drops every cached view. */
export function useSignOut(): () => void {
  const api = useApi();
  return useCallback(() => { setActingAs(null); void api.call("authLogout", undefined, undefined).finally(() => navigate(SIGN_IN_PATH)); }, [api]);
}
